import { render, staticRenderFns } from "./editActivo.vue?vue&type=template&id=63ebae16&"
import script from "./editActivo.vue?vue&type=script&lang=js&"
export * from "./editActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports